"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _chronological = _interopRequireDefault(require("./algorithm/chronological.js"));

var _greedy = _interopRequireDefault(require("./algorithm/greedy.js"));

var _item = _interopRequireDefault(require("./set/item.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Set = /*#__PURE__*/function () {
  /**
   * @constructs Set
   *
   * @param {*[]} items
   * @param {?function} extractor
   * @param {string} algorithm
   */
  function Set() {
    var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$extractor = _ref.extractor,
        extractor = _ref$extractor === void 0 ? function (i) {
      return i;
    } : _ref$extractor,
        _ref$algorithm = _ref.algorithm,
        algorithm = _ref$algorithm === void 0 ? 'greedy' : _ref$algorithm;

    _classCallCheck(this, Set);

    this.extractor = extractor;
    this.items = _item["default"].from(items, this.extractor);
    var AlgorithmClass = this.constructor.algorithms[algorithm];

    if (typeof AlgorithmClass === 'undefined') {
      throw new Error('Unsupported partitioning algorithm');
    }

    this.algorithm = AlgorithmClass;
    this.subsets = [];
  }
  /**
   * Partitions items into given number of subsets
   * according to the selected algorithm
   *
   * @param {number} count
   * @return {Subset[]}
   */


  _createClass(Set, [{
    key: "partition",
    value: function partition(count) {
      this.subsets = this.algorithm.partition(this.items, count);
      return this.subsets;
    }
    /**
     * Appends item to one of the subsets
     * according to selected algorithm and
     * returns the index of the selected subset
     *
     * @param {*} item
     * @return {number}
     */

  }, {
    key: "append",
    value: function append(item) {
      var wrapped = new _item["default"](item, this.extractor);
      this.items.push(wrapped);
      return this.algorithm.append(this.subsets, wrapped);
    }
  }]);

  return Set;
}();

exports["default"] = Set;

_defineProperty(Set, "algorithms", {
  greedy: _greedy["default"],
  chronological: _chronological["default"]
});